// helpers/mapHelpers.js
export const mapHelpers = {
  // Helper to convert rgba array to string
  rgbaToString: (rgba) => {
    if (Array.isArray(rgba)) {
      return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
    }
    return rgba; // Assume it's already a string
  },

  // Helper to calculate polygon area using shoelace formula
  calculatePolygonArea: (rings) => {
    if (!rings || rings.length === 0) return 0;

    try {
      // Using shoelace formula for more accurate area calculation
      const ring = rings[0]; // Use the outer ring
      if (!ring || ring.length < 3) return 0;

      let area = 0;
      let j = ring.length - 1;

      for (let i = 0; i < ring.length; i++) {
        area += (ring[j][0] + ring[i][0]) * (ring[j][1] - ring[i][1]);
        j = i;
      }

      return Math.abs(area / 2);
    } catch (error) {
      console.error('Error calculating polygon area:', error);
      return 0;
    }
  },

  // Helper to convert hex color to rgba array
  hexToRgba: (hex, opacity) => {
    // Handle hex colors with or without #
    const cleanHex = hex.replace('#', '');

    // Convert hex to RGB
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);

    return [r, g, b, opacity];
  },

  // Helper to validate coordinates
};
